import React from "react";

const SectionTitle = ({ children }) => (
  <div className="section-title">{children}</div>
);

export default SectionTitle;
